module.exports = __webpack_public_path__ + "static/media/only.237362df.png";